import ojb_logo from './ojb_logo.png';

export const ojbassests = {
  ojb_logo
}

